import {GET_STAFF_SURVEYS, GET_STAFF_SURVEYS_RESPONSES, GET_SUPPORT_TICKETS} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {urlGenerator} from "../../../common/Helper/AxiosHelper";
import {SURVEY_RESPONSE} from "../../../common/Config/apiUrl";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        function asset(path) {
            return `${window.location.origin}/${path}`;
        }
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                // cardViewComponent: 'app-package-card-view',
                name: this.$allLabel('surveys'),
                url: GET_STAFF_SURVEYS,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'custom-html',
                        key: 'title',
                        isVisible: true,
                        modifier: (title) => {
                            return title ? title: '-';
                        }
                    },
                    {
                        title: this.$t('description'),
                        type: 'custom-html',
                        key: 'description',
                        isVisible: true,
                        modifier: (description) => {
                            return description ? description: '-';
                        }
                    },
                    {
                        title: this.$t('start_date'),
                        type: 'custom-html',
                        key: 'start_date',
                        isVisible: true,
                        modifier: (start_date) => {
                            return start_date ?? '';
                        }
                    },
                    {
                        title: this.$t('end_date'),
                        type: 'custom-html',
                        key: 'end_date',
                        isVisible: true,
                        modifier: (end_date) => {
                            return end_date ?? '';
                        }
                    },
                    {
                        title: this.$t('user'),
                        type: 'custom-html',
                        key: 'user',
                        modifier: (user) => {
                            return user.name ?? "";
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: status => {
                            // Define badge classes for different statuses
                            let badgeClass = '';
                            switch (status) {
                                case 'Pending':
                                    badgeClass = 'secondary';
                                    break;
                                case 'Running':
                                    badgeClass = 'warning';
                                    break;
                                case 'Closed':
                                    badgeClass = 'success';
                                    break;
                                default:
                                    badgeClass = 'secondary';
                            }

                            // Return the HTML for the badge
                            return `<span class="badge badge-pill text-capitalize badge-${badgeClass}">
                                ${this.$t(status)}
                            </span>`;
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        title: this.$t('edit'),
                        url: GET_SUPPORT_TICKETS,
                        icon: 'edit',
                        key: "edit",
                        modifier: row => {
                            return row;
                        },
                    },
                    {
                        title: this.$t('details'),
                        url: `${SURVEY_RESPONSE}/3`,
                        icon: 'info',
                        key: "view_details",
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {

        },
        reloadSurveyTable() {
            this.isContextMenuOpen = false;
            this.$hub.$emit('reload-surveys-table')
        },
    }
}